import React from 'react';
import PropTypes from 'prop-types';
import OutlinedTextField from '../textFields/OutlinedTextField';
import SelectDropdown from '../SelectDropdown/SelectDropdown';
import DatePicker from '../../shared/DatePicker/DatePicker';
import StarRating from '../../shared/StarRating';
import Toggle from '../../shared/Toggle';
import { activities } from '../../../utils/activity_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';
import PrivacyTrigger from '@alltrails/shared/components/PrivacyTrigger';
import { VISIBILITY_PUBLIC, VISIBILITY_TO_OPTION } from '../../../utils/privacy_policy_helpers';

const TrackUploadFields = props => {
  const handleTextChange = e => {
    const { name, value } = e.currentTarget;
    const payload = { [name]: value };

    props.updateTrackForm(payload);
  };

  const handleActivityChange = e => {
    const value = e.currentTarget.dataset.value;
    const activity = activities.find(active => active.value === value);
    const payload = { activity };

    props.updateTrackForm(payload);
  };

  const handleNearbyTrailsChange = e => {
    const { value } = e.currentTarget.dataset;
    const payload = { trailId: parseInt(value) };

    props.updateTrackForm(payload);
  };

  const handleDateChange = date => {
    props.updateTrackForm({ date });
  };

  const handleRatingChange = (e, rating) => {
    e.preventDefault();
    props.updateTrackForm({ rating });
  };

  const togglePrivacy = e => {
    const isPrivate = e.currentTarget.checked;
    props.updateTrackForm({ isPrivate });
  };

  return (
    <div className={`${props.className}`}>
      <div className={`${styles.formSection} ${styles.topField}`}>
        <OutlinedTextField
          label={StringConstantsMixin.strings.TRACK_DETAIL.RECORDING_TITLE}
          value={props.name}
          name="name"
          changeHandler={handleTextChange}
        />
        <div className={styles.textInputSpacer} />
        <OutlinedTextField
          label={StringConstantsMixin.strings.TRACK_DETAIL.RECORDING_DESCRIPTION}
          value={props.description}
          changeHandler={handleTextChange}
          name="description"
          multiline
          rows={2}
        />
      </div>
      <div className={`${styles.formSection} ${styles.alignedLabel} ${styles.spaceBetween}`}>
        <div className={styles.labelName}>{StringConstantsMixin.strings.ACTIVITY}*</div>
        <div className={styles.dropdowns}>
          <SelectDropdown options={activities} handleChange={handleActivityChange} defaultItem={props.activity} isMobile={props.isMobile} slim />
          <DatePicker date={props.date} onChange={handleDateChange} locale={props.locale} slim />
        </div>
      </div>
      <div className={`${styles.formSection} ${styles.alignedLabel}`}>
        <div className={styles.labelName}>{StringConstantsMixin.strings.RATING}*</div>
        <div className={styles.starsContainer}>
          <StarRating handler={handleRatingChange} config={props.rating} iconClassName={styles.starRatingIconClass} />
        </div>
      </div>
      {props.nearbyTrails.length > 0 && (
        <div className={`${styles.formSection} ${styles.alignedLabel}`}>
          <div className={styles.labelName}>{StringConstantsMixin.strings.TRAIL}*</div>
          <div className={styles.nearbyTrailsContainer}>
            <SelectDropdown
              className={styles.trailDropdown}
              defaultItem={props.nearbyTrails.find(nb => nb.value === props.trailId)}
              options={props.nearbyTrails}
              handleChange={handleNearbyTrailsChange}
            />
          </div>
        </div>
      )}
      <div className={`${styles.formSection} ${styles.spaceBetween} ${styles.privacyContainer}`}>
        {props.flexiblePrivacy ? (
          <PrivacyTrigger
            onClick={props.handlePrivacyTriggerClick}
            label="Privacy"
            currentOption={VISIBILITY_TO_OPTION[props.contentPrivacy]}
          />
        ) : (
          <>
            <div className={styles.labelName}>{StringConstantsMixin.strings.PRIVATE}</div>
            <div>
              <Toggle inputId="listPrivacyToggle" onChange={togglePrivacy} checked={props.isPrivate} defaultChecked={props.private} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

TrackUploadFields.propTypes = {
  updateTrackForm: PropTypes.func,
  name: PropTypes.string,
  description: PropTypes.string,
  activity: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }),
  rating: PropTypes.number,
  isPrivate: PropTypes.bool,
  className: PropTypes.string,
  nearbyTrails: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    })
  ),
  flexiblePrivacy: PropTypes.bool
};

TrackUploadFields.defaultProps = {
  updateTrackForm: () => {},
  name: '',
  description: '',
  activity: {},
  rating: 0,
  isPrivate: false,
  nearbyTrails: [],
  className: '',
  flexiblePrivacy: false
};

export default TrackUploadFields;
